import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { catchError, map, mergeMap } from 'rxjs/operators';
import { FarmService } from '../_services';
import * as CurrentFarmActions from '../_actions/currentFarm';

@Injectable({
  providedIn: 'root',
})
export class CurrentFarmEffects {
  // Effetto per impostare l'utente corrente
  loadCurrentFarm$ = createEffect(() =>
    this.actions$.pipe(
      ofType(CurrentFarmActions.loadCurrentFarm),
      mergeMap(({ forceReload }) =>
        this.farmService.getCurrentFarm(forceReload).pipe(
          map((farm) => CurrentFarmActions.loadCurrentFarmSuccess({ farm })),
          catchError((error) => of(CurrentFarmActions.loadCurrentFarmFailure({ error })))
        )
      )
    )
  );

  constructor(
    private actions$: Actions,
    private farmService: FarmService
  ) {}
}
